export const red = {
  190: '#1A0103',
  175: '#400308',
  150: '#800610',
  125: '#BF0918',
  100: '#FF0C20',
  75: '#FF4958',
  50: '#FF4958',
  25: '#FFC2C7',
  10: '#FFE7E9',
  5: '#ffefef',
};
